import { createActionGroup, props } from '@ngrx/store';
import { ProductSummary } from '@mkp/product-summary/models';
import { CartCheckout } from '@mkp/cart/models';
import { CartDto } from '@mkp/publication/models';

export const productSummaryApiActions = createActionGroup({
  source: 'Product Summary API',
  events: {
    'Load Product Summary Success': props<{ productSummary: ProductSummary }>(),
    'Load Product Summary Failure': props<{ error: { message: string } }>(),
    'Product Checkout Success': props<{
      cartCheckout: CartCheckout;
      cart: CartDto;
      start?: string;
    }>(),
    'Product Checkout Failure': props<{ error: { message: string } }>(),
  },
});
